import {
  AllergyChartingAction,
  AllergyStatus,
  useGetAllergyChartingActions,
  usePatientAllergies,
} from "./network/useAllergies";
import {
  AdherenceStatus,
  MedicationChartingAction,
  useGetMedicationChartingActions,
  usePatientMedications,
} from "./network/useMedications";

export const useAvailableChartingActions = ({
  patientId,
}: { patientId: string }) => {
  const { data: activeMedications } = usePatientMedications({
    patientId,
    adherenceStatus: AdherenceStatus.ACTIVE,
  });
  const { data: activeAllergies } = usePatientAllergies({
    patientId,
    status: AllergyStatus.ACTIVE,
  });
  const { data: allergyChartingActions } =
    useGetAllergyChartingActions(patientId);
  const { data: medicationChartingActions } =
    useGetMedicationChartingActions(patientId);

  const isBatchConfirmAvailable =
    !allergyChartingActions?.find(
      (action) => action.action === AllergyChartingAction.CONFIRM_ALL_ALLERGIES,
    )?.unavailableReason &&
    !medicationChartingActions?.find(
      (action) =>
        action.action === MedicationChartingAction.CONFIRM_ALL_MEDICATIONS,
    )?.unavailableReason;

  const isNKDAAvailable = !allergyChartingActions?.find(
    (action) => action.action === AllergyChartingAction.DOCUMENT_ALLERGY,
  )?.unavailableReason;

  const isAddMedicationAvailable = !medicationChartingActions?.find(
    (action) => action.action === MedicationChartingAction.DOCUMENT_MEDICATION,
  )?.unavailableReason;
  const isAddAllergyAvailable = !allergyChartingActions?.find(
    (action) => action.action === AllergyChartingAction.DOCUMENT_ALLERGY,
  )?.unavailableReason;

  const isRetryFailedSubmissionAvailable = !medicationChartingActions?.find(
    (action) =>
      action.action === MedicationChartingAction.RETRY_FAILED_SUBMISSION,
  )?.unavailableReason;

  const isMarkPhonedInAvailable = !medicationChartingActions?.find(
    (action) => action.action === MedicationChartingAction.MARK_PHONED_IN,
  )?.unavailableReason;

  return {
    isBatchConfirmAvailable,
    isNKDAAvailable,
    isAddMedicationAvailable,
    isAddAllergyAvailable,
    isRetryFailedSubmissionAvailable,
    isMarkPhonedInAvailable,
    activeAllergies,
    activeMedications,
  };
};
